import { defineComponent as _defineComponent } from 'vue'
import type { SiffletColors } from '@/plugins/theme';

interface SAccordionProps {
  /**
   * Card title
   */
   texts: [string, string],
   backgroundColor?: SiffletColors,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SAccordion',
  props: {
  texts: null,
  backgroundColor: null
},
  setup(__props) {

const props = __props;




return { __sfc: true,props }
}

})